const language = window.localStorage.getItem('language');

export const emirates = [
    { value: -1, label: language === 'ar' ? 'اختر تسجيل الإمارة' : "Select Emirate Registration" },
    { value: 0, label: language === 'ar' ? 'أبوظبي' : "Abu Dhabi" },
    { value: 1, label: language === 'ar' ? 'عجمان' : "Ajman" },
    { value: 2, label: language === 'ar' ? 'دبي' : "Dubai" },
    { value: 3, label: language === 'ar' ? 'الفجيرة' : "Fujairah" },
    { value: 4, label: language === 'ar' ? 'رأس الخيمة' : "Ras Al Khaimah" },
    { value: 5, label: language === 'ar' ? 'الشارقة' : "Sharjah" },
    { value: 6, label: language === 'ar' ? 'أم القيوين' : "Umm Al Quwain" }
]

